export default __webpack_public_path__ + "static/media/close.6d9523e8.svg";